'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BoardImagePickerContainer = require('./BoardImagePickerContainer');

var _BoardImagePickerContainer2 = _interopRequireDefault(_BoardImagePickerContainer);

require('./IconTabContentImagePicker.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var IconTabContentImagePicker = function IconTabContentImagePicker(props) {
    return _react2.default.createElement(
        'div',
        { className: 'IconTabContentImagePicker' },
        _react2.default.createElement(_BoardImagePickerContainer2.default, props),
        _react2.default.createElement(
            'div',
            { className: 'instructions' },
            'Tip: 160 x 160px works best.'
        )
    );
};

// Styles


IconTabContentImagePicker.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    selectedElements: _propTypes2.default.object.isRequired,
    dispatchBoardImage: _propTypes2.default.func
};

exports.default = IconTabContentImagePicker;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/tabContent/imagePicker/IconTabContentImagePicker.js
// module id = 2246
// module chunks = 0